import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { metaSettingsService } from '../api/meta-settings.service';

export function useMetaSettings() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.metaSettings, queryFn: metaSettingsService.get });
  const save = useMutation({ mutationFn: (patch: Parameters<typeof metaSettingsService.update>[0]) => metaSettingsService.update(patch),
    onSuccess: (data) => client.setQueryData(queryKeys.metaSettings, data) });
  return { query, save };
}
